import React from 'react';
import { ResourceTypes, ResourceOperations } from '../../../authentication/resources';
import { Restricted } from '../../../authentication';
import { AdminHeaderLink, AdminRouterLink } from '../components/admin-area-menu-links';
import { joinURL } from '../../../utilities';
import { adminAreaPathName, auditTabPathName, auditlogWhitelistPathName, auditLogPathName } from '../admin-area-pathnames';
import { useTenantAddons, TenantAddonConstants } from '../../../components/tenant-addons';

export function AuditlogMenu() {
    const { isTenantAddonEnabled } = useTenantAddons();
    const isCitizenAccessJustificationEnabled = isTenantAddonEnabled([TenantAddonConstants.CitizenAccessJustification]);

    return (
        <Restricted
            actions={[
                { resourceType: ResourceTypes.AuditLog, resourceOperation: ResourceOperations.Read },
            ]}
        >
            {isCitizenAccessJustificationEnabled ? (
                <>
                    <AdminHeaderLink to={joinURL('/', adminAreaPathName, auditTabPathName)}>Brugerlog</AdminHeaderLink>

                    <AdminRouterLink to={joinURL('/', adminAreaPathName, auditTabPathName, auditLogPathName)}>Brugerlog</AdminRouterLink>
                    <AdminRouterLink to={joinURL('/', adminAreaPathName, auditTabPathName, auditlogWhitelistPathName)}>Relevansvurdering</AdminRouterLink>
                </>
            ) : (
                <AdminHeaderLink to={joinURL('/', adminAreaPathName, auditTabPathName)}>Brugerlog</AdminHeaderLink>
            )}
        </Restricted>
    );
}
